"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseQuery_1 = require("./BaseQuery");

var StatisticQuery =
/** @class */
function (_super) {
  __extends(StatisticQuery, _super);

  function StatisticQuery() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  StatisticQuery.prototype.initialize = function (executionOptions) {
    this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
  };

  StatisticQuery.prototype.getOptions = function () {
    var _a = this.queryOptions,
        key = _a.key,
        keyQuery = _a.keyQuery,
        _b = _a.options,
        options = _b === void 0 ? {} : _b;
    return __assign({
      key: key,
      keyQuery: keyQuery
    }, options.statistic || {});
  };

  StatisticQuery.prototype.getRawValue = function (executionOptions) {
    var key = this.options.key;
    var statistic = this.getStatistic(executionOptions);

    if (statistic) {
      if (key) {
        return statistic[key];
      }

      return statistic;
    }

    return;
  };

  return StatisticQuery;
}(BaseQuery_1.BaseQuery);

exports.StatisticQuery = StatisticQuery;